<template>
  <categoria-update
    :categoria="categoria"
    @cerrar-dialog="$emit('cerrar-dialog')"
    @update-category="actualizarCategoria"
  ></categoria-update>
</template>
<script>
import CategoriaUpdate from "@/components/categorias/categoria.update";
import ProductosAPI from "@/api/productos";
export default {
  name: "ProductoCategoriaUpdate",
  components: {
    CategoriaUpdate,
  },
  props: {
    categoria: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    async actualizarCategoria(categoriaActualizada) {
      const putData = {
        padre: categoriaActualizada.parent,
        name: categoriaActualizada.name,
      };

      try {
        await ProductosAPI.updateCategoria(categoriaActualizada.id, putData);

        if (categoriaActualizada.uso !== this.categoria.uso) {
          await ProductosAPI.patchCategoriaUso(categoriaActualizada.id, categoriaActualizada.uso);
        }

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Categoría actualizada",
          icon: "mdi-check",
          timeout: 3000,
        });
        this.$emit("refresh-categorias", categoriaActualizada);
        this.$emit("cerrar-dialog");
      } catch (e) {
        const message = e.response?.data?.detail || "Problema al actualizar";
        const incompatibles = e.response?.data?.incompatibles;
        const texto = incompatibles
          ? `${message}: ${incompatibles.join(", ")}`
          : message;

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: texto,
          icon: "mdi-alert-circle",
          timeout: 5000,
        });
        this.$emit("cerrar-dialog");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
